import { ReduxStore } from 'store/types';

function createThreadMessageIsLoading(state: ReduxStore): boolean {
  return state.intervention.createThreadMessage.config.isLoading;
}

export default createThreadMessageIsLoading;
